import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThreeVerticalDots = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M128 256c70.4 0 128-57.6 128-128s-57.6-128-128-128c-70.4 0-128 57.6-128 128s57.6 128 128 128zM128 384c-70.4 0-128 57.6-128 128s57.6 128 128 128c70.4 0 128-57.6 128-128s-57.6-128-128-128zM128 768c-70.4 0-128 57.6-128 128s57.6 128 128 128c70.4 0 128-57.6 128-128s-57.6-128-128-128z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgThreeVerticalDots);
export default ForwardRef;
